/**
 * Configuration for Propheseer WebUI
 */

const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

export const API_BASE_URL = isDevelopment
  ? 'http://localhost:7860'
  : (process.env.REACT_APP_API_URL || 'https://propheseer-api.vercel.app');

export const API_ENDPOINTS = {
  createForecast: `${API_BASE_URL}/forecast`,
  getForecast: (id) => `${API_BASE_URL}/forecast/${id}`,
  getForecastRound: (id, round) => `${API_BASE_URL}/forecast/${id}/rounds/${round}`,
  listForecasts: `${API_BASE_URL}/forecast`,
};

export const POLLING_CONFIG = {
  interval: 3000, // 3 seconds
  maxAttempts: 200, // ~10 minutes max (pipeline can take a while)
};

// Status display labels
export const STATUS_LABELS = {
  pending: 'Starting...',
  round_0: 'Generating Questions',
  searching: 'Searching for Information',
  round_1: 'Round 1: Initial Forecasts',
  mediator_1: 'Mediator Analysis 1',
  round_2: 'Round 2: Full Information',
  mediator_2: 'Mediator Analysis 2',
  round_3: 'Round 3: Final Forecasts',
  aggregating: 'Aggregating Results',
  complete: 'Complete',
  error: 'Error',
};

// Agent display info
export const AGENTS = {
  gerry: { name: 'Gerry', model: 'GPT-5.2', color: '#10b981' },
  owen: { name: 'Owen', model: 'Claude Opus', color: '#8b5cf6' },
  dan: { name: 'Dan', model: 'DeepSeek', color: '#f59e0b' },
};
